/** O slug sempre é exatamente um label DNS; a resolução do host decide se ele pertence ao domínio configurado antes de consultar o banco. */
const TENANT_SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export const RESERVED_TENANT_SLUGS = [
  'admin',
  'www',
  'api',
  'app',
  'assets',
  'static',
  'cdn',
  'media',
  'uploads',
  'status',
  'health',
  'auth',
  'login',
  'support',
  'billing',
  'mail',
  'webmail',
  'smtp',
  'imap',
  'pop',
  'autodiscover',
  'autoconfig',
  'localhost',
  'local',
  'dev',
  'development',
  'staging',
  'test',
  'preview',
  'prod',
  'production',
] as const;

const reservedTenantSlugs = new Set<string>(RESERVED_TENANT_SLUGS);
const DNS_NAMESERVER_LABEL = /^ns\d+$/;

export function normalizeTenantSlug(value: string): string {
  return value.trim().toLowerCase();
}

export function isTenantSlugAvailable(value: string): boolean {
  const slug = normalizeTenantSlug(value);
  return (
    TENANT_SLUG_PATTERN.test(slug) &&
    !reservedTenantSlugs.has(slug) &&
    !DNS_NAMESERVER_LABEL.test(slug)
  );
}

type TenantHost = { kind: 'tenant'; slug: string } | { kind: 'sys-admin' } | { kind: 'invalid' };

interface TenantHostOptions {
  baseDomain: string;
  sysAdminHost: string;
}

/** Classifica um hostname já extraído de uma URL (não aceita `Host` cru nem porta; sem consulta ao banco). */
export function parseTenantHost(hostname: string, options: TenantHostOptions): TenantHost {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  const baseDomain = options.baseDomain.toLowerCase().replace(/\.$/, '');
  const sysAdminHost = options.sysAdminHost.toLowerCase().replace(/\.$/, '');

  if (!host || !baseDomain || !sysAdminHost) {
    return { kind: 'invalid' };
  }
  if (host === sysAdminHost) {
    return { kind: 'sys-admin' };
  }

  const suffix = `.${baseDomain}`;
  if (!host.endsWith(suffix)) {
    return { kind: 'invalid' };
  }

  const slug = host.slice(0, -suffix.length);
  if (!isTenantSlugAvailable(slug)) {
    return { kind: 'invalid' };
  }

  return { kind: 'tenant', slug };
}
